import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaWhatsapp } from "react-icons/fa";
import "../styles/WhatsappSupport.css";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
const COMPANY_CODE = process.env.REACT_APP_COMPANY_CODE;

const WhatsappSupport = ({ message = "Hello, I need support!" }) => {
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch WhatsApp support number
  useEffect(() => {
    const fetchWhatsappNumber = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/customer/company/get-whatsapp-support`,
          {
            params: { company_code: COMPANY_CODE },
          }
        );
        setPhoneNumber(response.data.whatsapp_support_number);
      } catch (error) {
        setPhoneNumber(null);
      } finally {
        setLoading(false);
      }
    };

    if (COMPANY_CODE) {
      fetchWhatsappNumber();
    } else {
      setLoading(false);
    }
  }, []);

  // WhatsApp link handler
  const handleWhatsappClick = () => {
    if (!phoneNumber) {
      return;
    }
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  // Don't render if loading or no phone number available
  if (loading || !phoneNumber) {
    return null;
  }

  return (
    <FaWhatsapp
      className="whatsapp-support-btn"
      onClick={handleWhatsappClick}
      aria-label="Contact us on WhatsApp"
      title="Chat with us on WhatsApp"
    />
  );
};

export default WhatsappSupport;
